<!-- =========================================================================================
  File Name: ClientDetail.vue
  Description: Client Detail Page
  ----------------------------------------------------------------------------------------
  Item Name: iTOVi - Admin
========================================================================================== -->

<template>
  <div id="main-container">

    <div class="vx-row mt-5">
      <div class="vx-col sm:w-1/2 w-full mb-base">
        <h1>{{ client.first_name }} {{ client.last_name }}</h1>
      </div>
    </div>

    <vx-card>
      <h4 class="mb-4">Client Information</h4>

      <vs-row>
        <vs-col vs-w="6">
          <vs-row>
            <vs-col vs-w="4" style="font-weight: bold;">Name</vs-col>
            <vs-col vs-w="8">{{ client.first_name }} {{ client.last_name }}</vs-col>
          </vs-row>

          <vs-row>
            <vs-col vs-w="4" style="font-weight: bold;">Email</vs-col>
            <vs-col vs-w="8">{{ client.email }}</vs-col>
          </vs-row>

          <vs-row>
            <vs-col vs-w="4" style="font-weight: bold;">Phone</vs-col>
            <vs-col vs-w="8">{{ client.phone }}</vs-col>
          </vs-row>
        </vs-col>

        <vs-col vs-w="6">
          <vs-row>
            <vs-col vs-w="4" style="font-weight: bold;" v-if="isMeClient">User ID</vs-col>
            <vs-col vs-w="4" style="font-weight: bold;" v-else>Belongs to User</vs-col>
            <vs-col vs-w="8"><span style="cursor: pointer;" @click="$router.push('/users/detail?id=' + client.user_id).catch(() => {})">{{ client.user.first_name }} {{ client.user.last_name }} (ID: {{ client.user_id }})</span></vs-col>
          </vs-row>
        </vs-col>
      </vs-row>

      <vs-row class="mt-4">
        <vs-button @click="editClient()" class="ml-0">
          <feather-icon icon="EditIcon" svgClasses="h-4 w-4"/>
          <span class="text-sm font-semibold ml-2">EDIT</span>
        </vs-button>

        <vs-button v-if="!client.is_user" class="ml-auto" color="danger" icon="delete_outline" type="gradient" @click="confirmForgetClientEmail">Send Forget Client Email</vs-button>
        <vs-button v-if="!client.is_user" class="ml-2" color="danger" icon="delete_outline" type="gradient" @click="confirmForgetClient">Forget Client</vs-button>
      </vs-row>
    </vx-card>

  </div>
</template>

<script>
  import api from '@/http/api';
  import types from '@/models';
  import jsonHtml from '@/misc/jsonHtmlPrinter'

  import helpers from '@/models/helpers';

  export default {
    components: {

    },
    mounted() {
      this.fetchClient();
    },
    data() {
      return {
        jsonHtml: jsonHtml,
        unsavedChanges: {},
        types: types,
        isLoading: false,
        client: new types.Client(),
        helpers: helpers,
        showForgetButton: false,
        isMeClient: false,
      }
    },
    computed: {
      clientId() {
        return this.$route.query.id || null;
      },
      howManyUnsavedChanges() {
        let count = 0;
        let keys = Object.keys(this.unsavedChanges);
        for (let i = 0; i < keys.length; i++) {
          if (this.unsavedChanges[keys[i]]) {
            count++;
          }
        }
        return count;
      },
    },
    watch: {
      isLoading(oldVal, newVal) {
        if (!newVal) {
          this.$vs.loading();
        } else {
          this.$vs.loading.close();
        }
      }
    },
    methods: {
      showNotification(success, message) {
        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: message ? message : '',
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error'});
      },
      confirmForgetClientEmail() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          acceptText: 'SEND EMAIL',
          title: `SEND FORGET CLIENT EMAIL`,
          text: `Are you sure you want to send the forget client email to this client? (Client's personal information will be deleted if they reply confirming they want to do it.)`,
          accept: () => {
            this.forgetClientEmail();
          }
        })
      },
      async forgetClientEmail() {
        this.$vs.loading();
        const success = await api.sendForgetClientEmail(this.clientId);
        this.$vs.loading.close();
        this.showNotification(success, !success ? 'COULD NOT SEND FORGET CLIENT EMAIL' : '');
      },
      confirmForgetClient() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          acceptText: 'FORGET',
          title: `FORGET CLIENT`,
          text: `Are you sure you want to forget this client? This action is permanent. (Client's personal information will be deleted.)`,
          accept: () => {
            this.forgetClient();
          }
        })
      },
      async forgetClient() {
        this.$vs.loading();
        const success = await api.forgetClient(this.clientId);
        this.$vs.loading.close();
        this.showNotification(success, !success ? 'COULD NOT FORGET CLIENT' : '');
        if (success) {
          this.$router.go();
        }
      },
      async fetchClient() {
        this.$vs.loading();

        let client = await api.fetchClient(this.clientId);
        if (client === null) {
          // todo: handle error
        }

        this.client = client;

        this.isMeClient = this.client.client_id === this.client.user.client_id;

        this.$vs.loading.close();
      },
      editClient() {
        this.$router.push('/clients/edit?id=' + this.client.client_id);
      }
    },
    beforeRouteLeave(to, from, next) {
      if (this.howManyUnsavedChanges <= 0) {
        next();
      } else {
        // next(false);
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Confirm`,
          text: 'Are you sure you want to leave this page? You will lose your unsaved changes.',
          accept: () => {
            next()
          }
        });
      }
    },
  }

</script>


<style lang="scss">
  #main-container {

    .algolia-header {
      .algolia-filters-label {
        width: calc(260px + 2.4rem);
      }
    }

    #algolia-content-container {

      .vs-sidebar {
        position: relative;
        float: left;
      }
    }

    .algolia-search-input-right-aligned-icon {
      padding: 1rem 1.5rem;
    }

    .algolia-price-slider {
      min-width: unset;
    }

    .item-view-primary-action-btn {
      color: #2c2c2c !important;
      background-color: #f6f6f6;
      min-width: 50%;
    }

    .item-view-secondary-action-btn {
      min-width: 50%;
    }
  }

  .theme-dark {
    #main-container {
      #algolia-content-container {
        .vs-sidebar {
          background-color: #10163a;
        }
      }
    }
  }

  @media (min-width: 992px) {
    .vs-sidebar-rounded {
      .vs-sidebar {
        border-radius: .5rem;
      }

      .vs-sidebar--items {
        border-radius: .5rem;
      }
    }
  }

  @media (max-width: 992px) {
    #algolia-content-container {
      .vs-sidebar {
        position: absolute !important;
        float: none !important;
      }
    }
  }

</style>

